import { render } from "./AvaliacaoDiscursiva.vue?vue&type=template&id=0ce693ac&scoped=true"
import script from "./AvaliacaoDiscursiva.vue?vue&type=script&lang=js"
export * from "./AvaliacaoDiscursiva.vue?vue&type=script&lang=js"

import "./AvaliacaoDiscursiva.vue?vue&type=style&index=0&id=0ce693ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce693ac"]])

export default __exports__